'use client';
import {
  Conditional,
  DealerLocatorServicesOffered,
  DealerLocatorStoreContactInfo,
  DealerLocatorStoreHoursInfo,
  DealerStore
} from 'components/pcc-components';
import { useTranslations } from 'next-intl';
import { useLocationQuery } from 'services/locations/useLocationQuery';
import { StoreDetailsServerLoader } from './dealer-details-server-loader';

interface StoreDetailsServerProps {
  store: DealerStore;
  returnContactUrl: (storeId?: string) => string;
  isAvailByBranch?: boolean;
  isDealerLocationFlag?: boolean;
}
export const StoreDetailsServer = ({
  store,
  returnContactUrl,
  isAvailByBranch = false,
  isDealerLocationFlag = false
}: StoreDetailsServerProps) => {
  const { data, isPending } = useLocationQuery(
    store,
    isAvailByBranch,
    isDealerLocationFlag
  );
  const t = useTranslations();
  const isLoading = isPending && (isDealerLocationFlag || isAvailByBranch);
  const storeDetails = isDealerLocationFlag || isAvailByBranch ? data : store;
  return (
    <>
      <Conditional test={isLoading} fallback={null}>
        <StoreDetailsServerLoader />
      </Conditional>
      <Conditional test={!!storeDetails}>
        <div className="d-flex flex-wrap flex-column flex-lg-row px-1 py-2">
          <DealerLocatorStoreContactInfo
            contactInfoDrivingDirectionsLabel={t('DRIVING_DIRECTIONS')}
            contactInfoEmailLabel={t('MA_EMAIL')}
            contactInfoTitle={`${t('FOOTER_CUSTOMER_SERVICE')}:`}
            contactInfoWebsiteLabel={t('CU_WEBSITE')}
            returnContactUrl={returnContactUrl}
            store={storeDetails}
          />
          <DealerLocatorServicesOffered
            servicesOfferedTitle={`${t('SERVICES_OFFERED')}:`}
            store={storeDetails}
          />
          <DealerLocatorStoreHoursInfo
            store={storeDetails}
            storeHoursOpen24HrsTitle={t('OPEN_24_HOURS_7_DAYS_A_WEEK')}
            storeHoursTitle={`${t('STORE_HOURS')}:`}
          />
        </div>
      </Conditional>
    </>
  );
};
